import React, { createContext, useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"

import type { PropsWithChildren } from "react"

interface ProductDataProviderStaticGraphQLOutput {
  allProductData: {
    nodes: MergedProductData[]
  }
}

interface ProductDataContextType {
  allProductData: MergedProductData[]
}

const ProductDataContext = createContext<ProductDataContextType>({
  allProductData: [],
})

export const ProductDataProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const {
    allProductData: {
      nodes: allProductData
    },
  }: ProductDataProviderStaticGraphQLOutput =
    useStaticQuery(graphql`
      query {
        allProductData(
          filter: {
            published: { eq: true }
            isTestProduct: { ne: true }
          }
        ) {
          nodes {
            ...ProductDataExtended
          }
        }
      }
    `)

  return (
    <ProductDataContext.Provider
      value={{
        allProductData
      }}
    >
      {children}
    </ProductDataContext.Provider>
  )
}

export const useProductData = () => useContext(ProductDataContext)
